<template>
  <div class="boxs w-full flex-wrap overflow-y-auto">
    <div class="w-full col-span-full flex box justify-between items-center">
      <h3 class="flex w-full items-center">
        {{ $e("Appareils") }} :
        {{ $root?.devices?.online_compteur?.sitOnline[site.sit_id]?.online }} /
        {{ $root?.devices?.online_compteur?.sitOnline[site.sit_id]?.total }}
      </h3>
    </div>

    <template v-for="device in $root?.devices?.online" :key="device">
      <template v-if="device?.loaded === true">
        <template v-if="device?.sit_id === site.sit_id">
          <!-- ********** -->
          <template
            v-if="
              device?.config?.infoType == 'small' ||
              device?.config?.infoType == 'full'
            "
          >
            <Device_Info_Small :config="device.config" :deviceLink_active="false" />
          </template>

          <!-- <template v-if="device?.config?.infoType == 'device_externe'">
            <Device_Info_Externe :config="device.config" :deviceLink_active="false" />
          </template>

          <template v-if="device?.config?.infoType == 'device_aeroscope'">
            <Device_Info_Aeroscope :config="device.config" :deviceLink_active="false" />
          </template> -->
          <!-- ********** -->
        </template>
      </template>
    </template>

    <div
      class="box text-center text-g3 text-base"
      v-if="$root?.devices?.online?.length <= 0"
    >
      {{ $e("Aucun appareil connecté") }}
    </div>
  </div>
</template>


<script>
import { ref } from "vue";
import Back from "@/partials/Back.vue";
import Map from "@/utils/Map";

// ---
import Device_Info_Small from "@/partials/Device/Info/Device_Info_Small.vue";
import Device_Info_Externe from "@/partials/Device/Info/Device_Info_Externe.vue";
import Device_Info_Aeroscope from "@/partials/Device/Info/Device_Info_Aeroscope.vue";
import Device_Info_Offline from "@/partials/Device/Info/Device_Info_Offline.vue";

export default {
  name: "Site_Popup",
  components: {
    Back,
    Device_Info_Small,
    Device_Info_Externe,
    Device_Info_Aeroscope,
    Device_Info_Offline,
  },

  setup() {
    return {
      site: ref({}),
      main_active: ref(true),
    };
  },

  async mounted() {},

  async beforeMount() {
    this.site = this.$root.global.site;
    Map.focus({ lat: this.site.sit_lat, lng: this.site.sit_lng, hgt: 1500 });

    if (this.site.sit_geof != null) {
      let option = {
        name: this.site.sit_name,
        stroke: Cesium.Color.FIREBRICK,
        fill: Cesium.Color.FIREBRICK.withAlpha(0),
        strokeWidth: 30,
        markerSymbol: "?",
        // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      };
      Map.add_geometry(this.site.sit_geof, option, false);
    }

    if (this.site.sit_geom != null) {
      let option = {
        name: this.site.sit_name,
        stroke: Cesium.Color.WHITE,
        fill: Cesium.Color.WHITE.withAlpha(0),
        strokeWidth: 30,
        markerSymbol: "?",
        // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        // clampToGround: true,
      };
      Map.add_geometry(this.site.sit_geom, option, false);
    }
  },

  methods: {
    canEditSite() {
      return $root.user.can([4, 5], "SITES.all_allowed");
    },
  },

  computed: {
    AllDevice() {
      if (this.$root?.devices?.devices == undefined) {
        return 0;
      }
      return Object.keys(this.$root?.devices?.devices).length;
    },
    OnlineDevice() {
      if (this.$root?.devices?.online == undefined) {
        return 0;
      }
      return Object.keys(this.$root.devices.online).length;
    },
  },
};
</script>
